export const PIN_MIN_LENGTH = 5;
export const PIN_MAX_LENGTH = 30;
